export let TITLE_POSITION_VALUES;
(function (TITLE_POSITION_VALUES) {
  TITLE_POSITION_VALUES[TITLE_POSITION_VALUES["CENTER"] = 1] = "CENTER";
  TITLE_POSITION_VALUES[TITLE_POSITION_VALUES["BOTTOM"] = 2] = "BOTTOM";
})(TITLE_POSITION_VALUES || (TITLE_POSITION_VALUES = {}));
//# sourceMappingURL=title-position-values.js.map